import { render, staticRenderFns } from "./SimpleAlert.vue?vue&type=template&id=b662b62c"
import script from "./SimpleAlert.vue?vue&type=script&lang=js"
export * from "./SimpleAlert.vue?vue&type=script&lang=js"
import style0 from "./SimpleAlert.vue?vue&type=style&index=0&id=b662b62c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports